import {FC, useEffect, useMemo, useState} from "react";
import {Endpoints, TFile} from "@brg/api";
import styled from "styled-components";
import {useResizedImageEnhanced} from "../../hooks/useResizedImageEnhanced";
import {ChevronePrev} from "./chevronePrev";
import {ChevroneNext} from "./chevroneNext";
import {LayoutConst, useModal} from "../../../core";
import {FlexBox, useBreakpoint} from "@brg/ui";

const PreviewerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 32px;
  
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    column-gap: 24px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    column-gap: 16px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    row-gap: 16px;
    flex-direction: column;
  }
`

const PreviewerImage = styled.img`
  user-select: none;

  max-width: 920px;
  max-height: 920px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 740px;
    max-height: 730px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    max-width: 584px;
    max-height: 584px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    max-width: 300px;
    max-height: 300px;
  }
`

const ArrowBlock = styled.div`
  cursor: pointer;

  @media (max-width: ${LayoutConst.screen.m}px) {
    svg {
      width: 40px;
      min-width: 40px;
    }
`
const ArrowBlockEmpty = styled.div`
  width: 80px;
  min-width: 80px;

  @media (max-width: ${LayoutConst.screen.m}px) {
      width: 40px;
      min-width: 40px;
  }
`

const PreviewerImageWrapper = styled(FlexBox)`

  align-items: center;
  justify-content: center;
  width: 920px;
  height: 920px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 740px;
    height: 730px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 584px;
    height: 584px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 300px;
    height: 300px;
  }
`


export const PreviewerModal: FC<{activeAttachmentId?: string, attachmentList: {attachmentId: string, files: TFile[]}[]}> = ({activeAttachmentId, attachmentList}) => {

    const [currentIndex, setCurrentIndex] = useState(0)
    const activeImageFiles = useMemo(() => attachmentList?.[currentIndex]?.files || [], [currentIndex, attachmentList])
    const modal = useModal();
    const is744 = useBreakpoint(LayoutConst.screen.s);

    useEffect(() => {
        const index = attachmentList?.findIndex(imageItem => imageItem?.attachmentId === activeAttachmentId);
        if (index !== undefined && index !== -1) {
            setCurrentIndex(index)
            return;
        }

    }, [activeAttachmentId, attachmentList])

    const hasArrowPrev = useMemo(() => currentIndex > 0, [currentIndex])
    const hasArrowNext = useMemo(() => attachmentList?.length > (currentIndex + 1), [currentIndex, attachmentList])

    const [img, containerRef] = useResizedImageEnhanced(activeImageFiles);

    if (!attachmentList || attachmentList?.length === 0) return null;

    if (is744) return <PreviewerWrapper onClick={() => modal.hide()} ref={containerRef}>
        <PreviewerImageWrapper><PreviewerImage src={`${Endpoints.files}/${img?.url}`} onClick={e => e.stopPropagation()} alt=""/></PreviewerImageWrapper>
        <FlexBox gx={24}>
            {hasArrowPrev ? <ArrowBlock onClick={(e) => {e.stopPropagation(); setCurrentIndex(prev => prev - 1)}}><ChevronePrev/></ArrowBlock> : <ArrowBlockEmpty/>}
            {hasArrowNext ? <ArrowBlock onClick={(e) => {e.stopPropagation(); setCurrentIndex(prev => prev + 1)}}><ChevroneNext/></ArrowBlock> : <ArrowBlockEmpty/>}
        </FlexBox>
    </PreviewerWrapper>

    return <PreviewerWrapper onClick={() => modal.hide()} ref={containerRef}>
        {hasArrowPrev ? <ArrowBlock onClick={(e) => {e.stopPropagation(); setCurrentIndex(prev => prev - 1)}}><ChevronePrev/></ArrowBlock> : <ArrowBlockEmpty/>}
        <PreviewerImageWrapper><PreviewerImage src={`${Endpoints.files}/${img?.url}`} onClick={e => e.stopPropagation()} alt=""/></PreviewerImageWrapper>
        {hasArrowNext ? <ArrowBlock onClick={(e) => {e.stopPropagation(); setCurrentIndex(prev => prev + 1)}}><ChevroneNext/></ArrowBlock> : <ArrowBlockEmpty/>}
    </PreviewerWrapper>
}import {FC, useEffect, useMemo, useState} from "react";
import {Endpoints, TFile} from "@brg/api";
import styled from "styled-components";
import {useResizedImageEnhanced} from "../../hooks/useResizedImageEnhanced";
import {ChevronePrev} from "./chevronePrev";
import {ChevroneNext} from "./chevroneNext";
import {LayoutConst, useModal} from "../../../core";
import {FlexBox, useBreakpoint} from "@brg/ui";

const PreviewerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 32px;
  
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    column-gap: 24px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    column-gap: 16px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    row-gap: 16px;
    flex-direction: column;
  }
`

const PreviewerImage = styled.img`
  user-select: none;

  max-width: 920px;
  max-height: 920px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 740px;
    max-height: 730px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    max-width: 584px;
    max-height: 584px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    max-width: 300px;
    max-height: 300px;
  }
`

const ArrowBlock = styled.div`
  cursor: pointer;

  @media (max-width: ${LayoutConst.screen.m}px) {
    svg {
      width: 40px;
      min-width: 40px;
    }
`
const ArrowBlockEmpty = styled.div`
  width: 80px;
  min-width: 80px;

  @media (max-width: ${LayoutConst.screen.m}px) {
      width: 40px;
      min-width: 40px;
  }
`

const PreviewerImageWrapper = styled(FlexBox)`

  align-items: center;
  justify-content: center;
  width: 920px;
  height: 920px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 740px;
    height: 730px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 584px;
    height: 584px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 300px;
    height: 300px;
  }
`


export const PreviewerModal: FC<{activeAttachmentId?: string, attachmentList: {attachmentId: string, files: TFile[]}[]}> = ({activeAttachmentId, attachmentList}) => {

    const [currentIndex, setCurrentIndex] = useState(0)
    const activeImageFiles = useMemo(() => attachmentList?.[currentIndex]?.files || [], [currentIndex, attachmentList])
    const modal = useModal();
    const is744 = useBreakpoint(LayoutConst.screen.s);

    useEffect(() => {
        const index = attachmentList?.findIndex(imageItem => imageItem?.attachmentId === activeAttachmentId);
        if (index !== undefined && index !== -1) {
            setCurrentIndex(index)
            return;
        }

    }, [activeAttachmentId, attachmentList])

    const hasArrowPrev = useMemo(() => currentIndex > 0, [currentIndex])
    const hasArrowNext = useMemo(() => attachmentList?.length > (currentIndex + 1), [currentIndex, attachmentList])

    const [img, containerRef] = useResizedImageEnhanced(activeImageFiles);

    if (!attachmentList || attachmentList?.length === 0) return null;

    if (is744) return <PreviewerWrapper onClick={() => modal.hide()} ref={containerRef}>
        <PreviewerImageWrapper><PreviewerImage src={`${Endpoints.files}/${img?.url}`} onClick={e => e.stopPropagation()} alt=""/></PreviewerImageWrapper>
        <FlexBox gx={24}>
            {hasArrowPrev ? <ArrowBlock onClick={(e) => {e.stopPropagation(); setCurrentIndex(prev => prev - 1)}}><ChevronePrev/></ArrowBlock> : <ArrowBlockEmpty/>}
            {hasArrowNext ? <ArrowBlock onClick={(e) => {e.stopPropagation(); setCurrentIndex(prev => prev + 1)}}><ChevroneNext/></ArrowBlock> : <ArrowBlockEmpty/>}
        </FlexBox>
    </PreviewerWrapper>

    return <PreviewerWrapper onClick={() => modal.hide()} ref={containerRef}>
        {hasArrowPrev ? <ArrowBlock onClick={(e) => {e.stopPropagation(); setCurrentIndex(prev => prev - 1)}}><ChevronePrev/></ArrowBlock> : <ArrowBlockEmpty/>}
        <PreviewerImageWrapper><PreviewerImage src={`${Endpoints.files}/${img?.url}`} onClick={e => e.stopPropagation()} alt=""/></PreviewerImageWrapper>
        {hasArrowNext ? <ArrowBlock onClick={(e) => {e.stopPropagation(); setCurrentIndex(prev => prev + 1)}}><ChevroneNext/></ArrowBlock> : <ArrowBlockEmpty/>}
    </PreviewerWrapper>
}